// extracted by mini-css-extract-plugin
export var container = "_37-0";
export var icon = "_37-1";